import { Badge, createSvgIcon, Menu } from '@mui/material';
import React from 'react'
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications } from '../../../store/reducers/notifications';
import Notification from '../../Header/Notification';


const NotificationIcon = createSvgIcon(<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path></svg>)


const Notifications = () => {

    const dispatch = useDispatch();
    const notifications = useSelector(state=>state.notifications)
    const [showNotification, setShowNotification] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const arrowRef = useRef();
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => setAnchorEl(null)
    
    const [unreadCount, setUnreadCount] = useState(0);
    const [newNotification, setNewNotification] = useState(false);

    const handleNotificationBell = (e) => {
        setShowNotification(!showNotification)
        setAnchorEl(e.currentTarget)
        dispatch(getNotifications());
      }

    
    useEffect(()=>{
        if(notifications.count){
            setUnreadCount(prevUnreadCount=>{
              if(prevUnreadCount<notifications.unseen_notification_count){
                setNewNotification(true);
                setTimeout(()=>{
                  setNewNotification(false);
                },[3000])
              }
    
              return notifications.unseen_notification_count
            })
        }
    },[notifications])

    return (
        <div>
            {unreadCount
                    ?(
            <Badge color="primary" overlap="circular" className="badge-wrapper" onClick={handleNotificationBell} badgeContent={unreadCount}>
            <NotificationIcon className={newNotification?"notificaiton-bell animate":"notificaiton-bell"}  ref={arrowRef}/>
            </Badge>)
            : (<NotificationIcon className="notificaiton-bell" onClick={handleNotificationBell} ref={arrowRef}/>)
            }
            <Menu
                className="Popover-notification"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                >
                <Notification setOpen={setShowNotification} setAnchor={setAnchorEl}/>
                </Menu>
        </div>
    )
}

export default Notifications
